import { AdminDashboard } from "@pages/admin/Dashboard";
import { Users } from "@pages/admin/Users";
import { CreateUser } from "@pages/admin/CreateUser";
import { ManageUserPage } from "@pages/admin/ManageUserPage";
import { UserProfilePage } from "@pages/admin/UserProfilePage";
import { UserLogsPage } from "@pages/admin/UserLogsPage";
import { ManageUserSubscriptionPage } from "@pages/admin/ManageUserSubscriptionPage";
import { SubscriptionPlansPage } from "@pages/admin/SubscriptionPlansPage";
import { SubscriptionOffersPage } from "@pages/admin/SubscriptionOffersPage";
import { EventSubscriptionsAuditPage } from "@pages/admin/EventSubscriptionsAuditPage";
import { SubscriptionDeliveriesAuditPage } from "@pages/admin/SubscriptionDeliveriesAuditPage";
import { AppRoute } from "./types";
import { UserRoles } from "@store/auth.store";

export const adminRoutes: AppRoute[] = [
  { path: "/admin", element: <AdminDashboard />, roles: [UserRoles.Admin] },
  { path: "/admin/users", element: <Users />, roles: [UserRoles.Admin] },
  {
    path: "/admin/users/create",
    element: <CreateUser />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/users/:userId",
    element: <UserProfilePage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/users/:userId/edit",
    element: <ManageUserPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/users/:userId/thread-logs",
    element: <UserLogsPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/users/:userId/thread-logs/:threadId",
    element: <UserLogsPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/users/:userId/subscription",
    element: <ManageUserSubscriptionPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/subscription-plans",
    element: <SubscriptionPlansPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/subscription-offers",
    element: <SubscriptionOffersPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/event-subscriptions",
    element: <EventSubscriptionsAuditPage />,
    roles: [UserRoles.Admin],
  },
  {
    path: "/admin/event-subscriptions/:subscriptionId/deliveries",
    element: <SubscriptionDeliveriesAuditPage />,
    roles: [UserRoles.Admin],
  },
];
